import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateFnsAdapter, provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxMatDatepickerInput, NgxMatDatetimepicker, NgxMatNativeDateModule } from '@ngxmc/datetime-picker';
import { AfmPortaalCommonModule } from 'afm-portaal-common';
import { nl } from 'date-fns/locale';
import AppConfigService from 'src/app/shared/services/app-config.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ConfirmationComponent } from './form/confirmation/confirmation.component';
import { FormComponent } from './form/form.component';
import { ContactInfoComponent } from './form/steps/step1/contact-info.component';
import { PersonFormComponent } from './form/steps/step1/person-form/person-form.component';
import { FinancialInstrumentComponent } from './form/steps/step2/financial-instrument/financial-instrument.component';
import { MarketComponent } from './form/steps/step2/market/market.component';
import { TransactionComponent } from './form/steps/step2/transaction.component';
import { NatureOfSuspicionComponent } from './form/steps/step3/nature-of-suspicion.component';
import { IdentityOfSuspectComponent } from './form/steps/step4/identity-of-suspect.component';
import { LegalPersonComponent } from './form/steps/step4/legal-person/legal-person.component';
import { NaturalPersonComponent } from './form/steps/step4/natural-person/natural-person.component';
import { SuspectFormComponent } from './form/steps/step4/suspect-form/suspect-form.component';
import { AdditionalInformationComponent } from './form/steps/step5/additional-information.component';
import { DocumentationAttachedComponent } from './form/steps/step6/documentation-attached.component';
import { OverviewComponent } from './overview/overview.component';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { SharedModule } from './shared/shared.module';

const DUTCH_DATE_FORMAT = {
  parse: {
      dateInput: 'DD-MM-YYYY',
  },
  display: {
      dateInput: 'DD-MM-YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    DashboardComponent,
    ContactInfoComponent,
    TransactionComponent,
    FinancialInstrumentComponent,
    PersonFormComponent,
    MarketComponent,
    NatureOfSuspicionComponent,
    IdentityOfSuspectComponent,
    SuspectFormComponent,
    NaturalPersonComponent,
    LegalPersonComponent,
    AdditionalInformationComponent,
    DocumentationAttachedComponent,
    ConfirmationComponent,
    OverviewComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatStepperModule,
    SharedModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatRadioModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    NgxMatDatepickerInput,
    NgxMatDatetimepicker,
    NgxMatNativeDateModule,
    AfmPortaalCommonModule
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((config: AppConfigService) => config.init)(inject(AppConfigService));
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: nl },
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DUTCH_DATE_FORMAT },
    provideDateFnsAdapter(),
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }
